export default {
  MINE_CHAR: String.fromCodePoint(0x1f4a3), // BOMB
  WON_MINE_CHAR: String.fromCodePoint(0x1f3c6), // TROPHY
  UNOPENED_SQUARE_CHAR: String.fromCodePoint(0x2b1b), // BLACK BOX
  MARKED_MINE_CHAR: String.fromCodePoint(0x2692) // HAMMER AND PICK
};



// WEBPACK FOOTER //
// ./src/constants.js